"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaName = void 0;
/**
 *
 */
var SchemaName;
(function (SchemaName) {
    SchemaName["main"] = "main";
    SchemaName["category"] = "category";
    SchemaName["inspiration"] = "inspiration";
    SchemaName["page"] = "page";
    SchemaName["product"] = "product";
    SchemaName["service"] = "service";
})(SchemaName || (exports.SchemaName = SchemaName = {}));
